import MiBtn from './MiBtn.vue'

export default MiBtn
